import React from "react";
import { motion } from "framer-motion";
import "./Portfolio.scss";
import { PortfolioData } from "./PortfolioData";

function Portfolio() {
  return (
    <>
      <div id="portfolio" className="portfolio_section">
        <h1 className="portfolio-title">Portfolio</h1>
        <div className="portfolio_list">
          {PortfolioData.map((portfolio, index) => {
            return (
              <div className="portfolio_item" key={index}>
                <div className="portfolio_img">
                  <motion.img
                    whileInView={{ x: [-20, 0], opacity: [0, 1] }}
                    transition={{ duration: 0.7 }}
                    src={portfolio.img}
                    alt={portfolio.title}
                  />
                </div>
                <motion.div
                  whileInView={{ x: [20, 0], opacity: [0, 1] }}
                  transition={{ duration: 1 }}
                  className="portfolio_text"
                >
                  <h2>{portfolio.title}</h2>
                  <p>{portfolio.desc}</p>
                </motion.div>
                <motion.div
                  whileInView={{ x: [-20, 0], opacity: [0, 1] }}
                  transition={{ duration: 1.5 }}
                  className="portfolio_buttons"
                >
                  <a
                    href={portfolio.link}
                    className="live_demo"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Live Demo
                  </a>
                  <a
                    href={portfolio.github}
                    className="github"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Repo
                  </a>
                </motion.div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default Portfolio;
